import api from './api'
import { BASE } from './config'

import { DEFAULT_PAGINATION_LIMIT } from '../constants/common'

class CliniciansService {
  getCliniciansList({ params, cancelToken }) {
    return api.get(`${BASE}/users/clinicians/`, {
      params: { ...params, limit: DEFAULT_PAGINATION_LIMIT },
      cancelToken,
    })
  }

  getClinicianDetails({ uuid }) {
    return api.get(`${BASE}/users/clinicians/${uuid}/`)
  }

  updateClinicianDetails({ uuid, data }) {
    return api.patch(`${BASE}/users/clinicians/${uuid}/`, data)
  }

  approveClinicianDocuments({ uuid, data }) {
    return api.post(`${BASE}/users/clinicians/${uuid}/approve-documents/`, data)
  }

  deleteClinicianDocument({ uuid }) {
    return api.delete(`${BASE}/files/document_files/${uuid}/`)
  }

  getClinicianDocument({ uuid }) {
    return api.get(`${BASE}/files/document_files/${uuid}/`)
  }

  uploadClinicianDocumentFile(file) {
    const formData = new FormData()
    formData.append('file', file)

    return api.post(`${BASE}/files/document_files/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  addClinicianDocument({ uuid, data }) {
    return api.post(`${BASE}/users/clinicians/${uuid}/upload-documents/`, data)
  }

  getClinicianDocuments({ params }) {
    return api.get(`${BASE}/users/clinicians/documents/`, {
      params: { ...params, limit: DEFAULT_PAGINATION_LIMIT },
    })
  }

  getClinicianDocumentsFilterList() {
    return api.get(`${BASE}/users/clinicians/documents/filter_list/`)
  }

  getClinicianFilterList() {
    return api.get(`${BASE}/users/clinicians/filter_list/`)
  }

  updateClinicianDocument({ clinicianUuid, documentId, data }) {
    return api.patch(
      `${BASE}/users/clinicians/${clinicianUuid}/documents/${documentId}/`,
      data
    )
  }

  updateClinicianQualification({ uuid, data }) {
    return api.put(`${BASE}/users/clinicians/${uuid}/qualification/`, data)
  }
}

export default new CliniciansService()
